module.exports = __webpack_public_path__ + "media/images/card_discover-b1dc2056e3689cec433d75a3785fb0a4.jpg";